import { NA_VALUE } from "./utils";

// The breakdown endpoint marks an unresolved industry segment either as "-" or as a
// literal "Unknown" — both should render as an em dash rather than a real segment.
const UNKNOWN_INDUSTRY_TOKENS = new Set(["-", "unknown"]);

const PATH_SEPARATOR = " › ";

export const isKnownIndustrySegment = (segment: string): boolean =>
    Boolean(segment) && !UNKNOWN_INDUSTRY_TOKENS.has(segment.trim().toLowerCase());

const prettifyIndustrySegment = (segment: string): string =>
    isKnownIndustrySegment(segment) ? segment.replace(/_/g, " ") : NA_VALUE;

// The most specific known segment — the sub-industry when present, otherwise the industry.
export const getLeafIndustry = (category: string, subCategory: string): string =>
    isKnownIndustrySegment(subCategory) ? prettifyIndustrySegment(subCategory) : prettifyIndustrySegment(category);

// Full "Industry › Sub-industry" path; collapses to the industry alone when there is no sub-industry.
export const formatIndustryPath = (category: string, subCategory: string): string =>
    isKnownIndustrySegment(subCategory)
        ? `${prettifyIndustrySegment(category)}${PATH_SEPARATOR}${prettifyIndustrySegment(subCategory)}`
        : prettifyIndustrySegment(category);
